<template>
  <div class=" w-screen h-screen flex bg">
    <div class="dark:bg-gray-900 transition-colors duration-300 bg-gray-50 m-auto w-3/4 xl:w-1/2 h-1/2 rounded-md shadow-lg py-8 overflow-y-scroll lg:overflow-y-hidden">
      <transition name="fade">
        <div v-if="currentComp == 1">
          <SignIn @clickToChange="changeComponent" />
          <span class="w-full flex">
            <button @click="currentComp = 2" class="mx-auto cursor-pointer text-sm text-center text-indigo-500 select-none mt-2">Não possui cadastro? Realize aqui</button>
          </span>
        </div>
        <div v-else-if="currentComp == 2">
          <SignUp @clickToChange="changeComponent"/>
          <span class="w-full flex">
            <button @click="currentComp = 1" class="mx-auto cursor-pointer text-sm text-center text-indigo-500 select-none mt-2">Já possui cadastro? Voltar para login</button>
          </span>
        </div>
        <div v-else>
          <RequestRecovery @clickToChange="changeComponent"/>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import SignIn from '@/components/Auth/SignIn'
import SignUp from '@/components/Auth/SignUp'
import { ref } from '@vue/reactivity'
import RequestRecovery from '@/components/Auth/RequestRecovery'

export default {
    name: 'Auth',
    components: {
      SignIn, SignUp, RequestRecovery
    },
    setup() {
      const currentComp = ref(1)

      const changeComponent = ((value) => {
        currentComp.value = value
      })

      return {
        currentComp, changeComponent
      }
    }
}
</script>

<style scoped>
.fade-enter-from {
  opacity: 0;
  transform: translateY(-10%);
}
.fade-enter-to {
  opacity: 1;
  transform: translateY(0%);
}

.fade-enter-active {
  transition: all 0.5s ease-in-out;
  transition-delay: 0.5s;
}

.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
  transform: translateY(0%);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(10%);
}

.bg {
background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1844%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='url(%23SvgjsLinearGradient1845)'%3e%3c/rect%3e%3cpath d='M1440 0L1122.33 0L1440 58.89z' fill='rgba(255%2c 255%2c 255%2c .1)'%3e%3c/path%3e%3cpath d='M1122.33 0L1440 58.89L1440 97.5L659.2099999999999 0z' fill='rgba(255%2c 255%2c 255%2c .075)'%3e%3c/path%3e%3cpath d='M659.21 0L1440 97.5L1440 293.12L393.01000000000005 0z' fill='rgba(255%2c 255%2c 255%2c .05)'%3e%3c/path%3e%3cpath d='M393.01 0L1440 293.12L1440 357.85L128.21999999999997 0z' fill='rgba(255%2c 255%2c 255%2c .025)'%3e%3c/path%3e%3cpath d='M0 560L10.79 560L0 553.57z' fill='rgba(0%2c 0%2c 0%2c .1)'%3e%3c/path%3e%3cpath d='M0 553.57L10.79 560L744.2099999999999 560L0 322.96000000000004z' fill='rgba(0%2c 0%2c 0%2c .075)'%3e%3c/path%3e%3cpath d='M0 322.96L744.2099999999999 560L1060.12 560L0 230.42999999999998z' fill='rgba(0%2c 0%2c 0%2c .05)'%3e%3c/path%3e%3cpath d='M0 230.42999999999995L1060.12 560L1082.54 560L0 123.28999999999995z' fill='rgba(0%2c 0%2c 0%2c .025)'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1844'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3clinearGradient x1='50%25' y1='100%25' x2='50%25' y2='0%25' gradientUnits='userSpaceOnUse' id='SvgjsLinearGradient1845'%3e%3cstop stop-color='rgba(27%2c 26%2c 52%2c 1)' offset='0.09'%3e%3c/stop%3e%3cstop stop-color='rgba(27%2c 26%2c 52%2c 1)' offset='0.09'%3e%3c/stop%3e%3cstop stop-color='rgba(55%2c 48%2c 163%2c 1)' offset='1'%3e%3c/stop%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e");

    background-size: 100% 100%;
    background-position: center top;
    background-attachment: fixed;
}

</style>
